<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M17.1 9.00039C17.1 13.4739 13.4735 17.1004 9.00002 17.1004C4.52652 17.1004 0.900024 13.4739 0.900024 9.00039C0.900024 4.52688 4.52652 0.900391 9.00002 0.900391C13.4735 0.900391 17.1 4.52688 17.1 9.00039ZM2.52002 9.00039C2.52002 12.5792 5.42122 15.4804 9.00002 15.4804C12.5788 15.4804 15.48 12.5792 15.48 9.00039C15.48 5.42159 12.5788 2.52039 9.00002 2.52039C5.42122 2.52039 2.52002 5.42159 2.52002 9.00039Z"
            fill="#878788"
        />
        <path
            d="M9.00002 17.1004C7.28947 17.1004 5.62283 16.5589 4.23896 15.5534L5.19118 14.2428C6.29827 15.0472 7.63158 15.4804 9.00002 15.4804V17.1004Z"
            fill="currentColor"
        />
    </svg>
</template>
